import { GridFilterItem, GridLinkOperator } from "@mui/x-data-grid-pro"

export type Option = {
    value: string,
    name: string
}

export type Filter = {
    id: string,
    description: string,
    searchTerm: string
    activityDate: string,
    startDate?: string,
    endDate?: string,
    hasNextActivity?: boolean,
    filterType: FilterType,
    options: OptionWithSelect[]    
}

export type FilterWithGridCriteria = Filter & {    
    refinedFilters: GridFilterItem[],
    refinedFiltersLinkOperator: GridLinkOperator
}

export enum FilterType {
    User,
    Playbook,
    ICP
}

export type OptionWithSelect = Option & {
    id: string,
    parentId: string,
    optionType: string
    selected: boolean,
    inclusive: boolean
}


export type FilterCategory = {
    category: string,
    icon: string,
    optionType: string,
    children: FilterCategory[],
    options: OptionWithSelect[],
    filteredOptions: OptionWithSelect[],
    hasMore: boolean
}